import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const ExpressAuthorization = forwardRef(({ data, refToPrint }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {},
            }
        },
    }))

    return (
        <div ref={refToPrint} className="flex items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-gray-800">
                        Express Authorization (DPPA &amp; GLBA)
                    </h1>
                    <p className="text-base text-gray-700">
                        I, the undersigned, hereby provide my <strong>express written consent to VerifiedID LLC and
                            its authorized agents</strong> to access and verify my personal information under the
                        following statutes:
                    </p>
                </div>

                <div className="space-y-4 text-gray-700 text-sm sm:text-base">
                    <div className="space-y-1">
                        <h2 className="font-semibold text-gray-800">1. Driver's Privacy Protection Act (DPPA)</h2>
                        <p>
                            I authorize the collection and verification of information contained in my
                            government-issued driver's license or motor vehicle record pursuant to the{' '}
                            <strong>Driver's Privacy Protection Act (18 U.S.C. § 2721)</strong> and similar state
                            laws. This data is used solely to authenticate my identity and prevent impersonation fraud.
                        </p>
                    </div>

                    <div className="space-y-1">
                        <h2 className="font-semibold text-gray-800">2. Gramm-Leach-Bliley Act (GLBA)</h2>
                        <p>
                            I authorize the collection and use of the <strong>last four digits of my Social
                                Security Number</strong> and other non-public personal information (NPI) governed by
                            the <strong>Gramm-Leach-Bliley Act (15 U.S.C. § 6801).</strong> This information is
                            used for institutional risk control and to protect against potential identity fraud.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default ExpressAuthorization
